import PropTypes from 'prop-types';

export default PropTypes.shape({
  order: PropTypes.number,
  locationName: PropTypes.string,
  address1: PropTypes.string,
  address2: PropTypes.string,
  citystatezip: PropTypes.string,
  slug: PropTypes.string,
  localizationSlug: PropTypes.string,
  phoneNumber: PropTypes.string,
  thumbnail: PropTypes.shape({
    fluid: PropTypes.object,
    title: PropTypes.string
  }),
  heroImage: PropTypes.shape({
    fluid: PropTypes.object
  }),
  description: PropTypes.string,
  leadershipLabel: PropTypes.string,
  leadershipTitle: PropTypes.string,
  leadershipBodyRichText: PropTypes.object,
  leaders: PropTypes.array,
  ourPurpose: PropTypes.object,
  quote: PropTypes.object,
  photoTitle: PropTypes.string,
  photos: PropTypes.array
});
